// extracted by mini-css-extract-plugin
module.exports = {"inspect-button":"inspect-button___84iiQ","is-header":"is-header___1Mfi8","is-footer":"is-footer___U45m_","is-save":"is-save___3jItI"};